export default __webpack_public_path__ + "static/media/uploader-medtronic-1.7bb798f7.png";